export default __webpack_public_path__ + "static/media/Shower.62ca1869.png";